import { colors } from '../../colors';
var form = {
  bgColor: colors.white,
  labelColor: colors.white,
  errorColor: colors.white,
  borderColor: colors.white,
  linkColor: colors.white,
  documentFormBgColor: colors.white
};
export default form;